class LockableMap {

    constructor() {
        this._map           = loadMapFromSessionStorage();
        this._locked        = false;

        window.addEventListener("beforeunload", () => saveMapToSessionStorage(this._map));
    }

    set(key, value) {
        if (!this.has(key)) {
            this._map.set(key, value);
        }
        else {

        }
    }

    get(key) {
        return this._map.get(key);
    }

    has(key) {
        return this._map.has(key);
    }

    isLocked() {
        return this._locked;
    }

    entries() {
        return this._map.entries();
    }

    toObject() {
        return Object.freeze(Object.fromEntries(this._map));
    }
}

const STORAGE_KEY = "mapData";

const saveMapToSessionStorage = (map) => {
    const obj = Object.fromEntries(map);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
};

const loadMapFromSessionStorage = () => {
    const stored = sessionStorage.getItem(STORAGE_KEY);

    if (stored) {
        const obj = JSON.parse(stored);
        return new Map(Object.entries(obj));
    }
    return new Map();
};

const lockableMap = new LockableMap();

export { lockableMap };
